export default "__VITE_ASSET__6002e7fc__"